"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersPenalized = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FilterPenalized = require("./components/FilterPenalized");
/**
 * Выводит список фильтров, под которые данный отель не попал
 */
var FiltersPenalized = exports.FiltersPenalized = function FiltersPenalized(props) {
  var penalized_filters = props.penalized_filters,
    onChangeFilter = props.onChangeFilter,
    className = props.className,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  if ((0, _isEmpty2["default"])(penalized_filters)) return null;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: className
  }, penalized_filters.map(function (filter) {
    return /*#__PURE__*/_react["default"].createElement(_FilterPenalized.FilterPenalized, {
      key: [filter.filterName, filter.filterValue].join(),
      isMobile: isMobile,
      filter: filter,
      onChangeFilter: onChangeFilter
    });
  }));
};
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "FiltersPenalized__Wrapper",
  componentId: "sc-15esapj-0"
})(["display:flex;flex-wrap:wrap;gap:8px;"]);